/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_CheckingInputs */

const en_common_checking = /** @type {(inputs: Common_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checking…`)
};

const es_common_checking = /** @type {(inputs: Common_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprobando…`)
};

/**
* | output |
* | --- |
* | "Checking…" |
*
* @param {Common_CheckingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_checking = /** @type {((inputs?: Common_CheckingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_CheckingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_checking(inputs)
	return en_common_checking(inputs)
});